module.exports = __webpack_public_path__ + "img/nldt2.23ddd5ab.png";